export const galleryData = {
  title: "Unsere Highlights von 2014-2025",
  subtitle: "Fotogalerie",
  text: "Der heutige Angler-Verein 'Angelfreunde 1866 e.V.' Berlin entstand 1858 und wurde am 08. März 1866 als 'Central-Verein der Angelfreunde zu Berlin' in das Vereinsregister eingetragen. Er ist Deutschlands ältester Anglerverein, gehört zum DAV Landesverband Berlin (Bezirksanglerverband Berlin-Friedrichshain im DAV).",
};

const unsortedItems = [
  { title: "2025", description: "weitere Fotos", imageSrc: "/gallery/2025/Angeltreff/1.jpeg", link: "/gallery/2025" },
];

export const items = unsortedItems.sort((a, b) => Number(b.title) - Number(a.title));
